import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import RenderTable from "../../../../components/RenderTable";
import { apiConfig } from "../../../../config/apiConfig";
import { useCookie } from "../../../../hooks/useCookie";
import { general } from "../../../../locales/general";
import apiService from "../../../../service/apiService";
import CouponUsageTable from "./CouponUsageTable";
import Pagination from "../../../../components/Pagination";
import { useState } from "react";

type UsageResponse = {
  items: CouponUsage[];
  meta: PaginationMeta;
};
export default function UsageDetails() {
  const { id } = useParams();
  const { token } = useCookie("vToken");
  const [currentPage, setCurrentPage] = useState(1);

  const endpoint = apiConfig.taxiCoupon.get_usage(id!, { page: currentPage });

  const { data, isLoading } = useQuery<UsageResponse>({
    queryKey: ["couponUsages", endpoint, token],
    queryFn: () => {
      return apiService.MakeGetRequest(endpoint, token);
    },
  });

  return (
    <div>
      <RenderTable
        render={() =>
          data?.items && data?.items?.length > 0 ? (
            <CouponUsageTable couponUsages={data.items} />
          ) : (
            <p className="text-center fs-5 my-2">{general.fr.noResultsFound}</p>
          )
        }
        loading={isLoading}
      />

      <Pagination
        onPageChange={(page) => setCurrentPage(page)}
        totalCount={data?.meta?.totalPages ?? 0}
        siblingCount={2}
        currentPage={currentPage}
        pageSize={10}
      />
    </div>
  );
}
